import { useAws } from "src/networking/aws/aws.hook";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetAccidentDataDraft,
  PutAccidentDataDraft,
  ServiceType,
  VerifyResponsibility,
} from "src/types";

export const useGetAccidentDataDraft = <
  T extends GetAccidentDataDraft["request"],
  D extends GetAccidentDataDraft["response"],
>() => {
  const hook = useAws<T, D>("getAccidentDataDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "get",
          path: `/bozza/${draftId}/datiGenerali`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePutAccidentDataDraft = <
  T extends PutAccidentDataDraft["request"],
  D extends PutAccidentDataDraft["response"],
>() => {
  const hook = useAws<T, D>("putAccidentDataDraft", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.uriParams.idBozza;

      return hook.crossGate(
        {
          method: "put",
          path: `/bozza/${draftId}/datiGenerali`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useVerifyResponsibility = <
  T extends VerifyResponsibility["request"],
  D extends VerifyResponsibility["response"],
>() => {
  const hook = useAws<T, D>("verifyResponsibility", ServiceType.CAI);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: "/bozza/verificaResponsabilita",
          ...request,
        },
        callbacks
      );
    },
  };
};
